'use client';

/**
 * @file
 * App Wide hooks shared across all layouts run here. This does not wrap the entire app so re-renders are isolated.
 * That's why this is a component that renders nothing.
 * @see {./(main)/app-hooks.tsx} for app wide hooks that are specific to the main layout
 */

import { useDatadogLogger, useDataDogRum } from '@/services/datadog';
import { ReactNode, Suspense } from 'react';

const GlobalAppHooksInner = (): ReactNode => {
  useDatadogLogger();
  useDataDogRum();
  return null;
};

export const GlobalAppHooks = () => (
  <Suspense fallback={null}>
    <GlobalAppHooksInner />
  </Suspense>
);
